import {
    Button, Divider, Icon, Stack, Box,
    Typography, FormControlLabel, Checkbox
} from '@mui/material'

import { Fragment, useEffect, useRef, useState } from 'react'

import { useSelector } from 'react-redux'

import { useLandingZoneMigration } from '@features/hooks/LandingZones/migration'

import Link from '@components/Link'
import Alert from '@components/Alert'

import RequestHelp from '@views/Landingzones/Migration/Components/RequestHelp'

export const Internet = () => {
    const dataStore = useSelector(state => state.landingZoneMigration)

    const { getStatus, handleNext, handlePrevious } = useLandingZoneMigration()

    const [inProgress, setInProgress] = useState(false)
    const [checked, setChecked] = useState(false)

    const timer = useRef()

    useEffect(() => {
        timer.current = setInterval(checkInterval, 10000)
        return () => { clearInterval(timer.current) }
    }, [])

    useEffect(() => {
        setInProgress(dataStore.selected.inProgress)
    }, [dataStore.selected])

    const checkInterval = () => {
        getStatus(dataStore.selected.lzId, false)
    }

    return (
        <Fragment>
            <Divider sx={{mt: 2}}/>
            <Box sx={{p: 2}}>
                <Typography variant={'h5'} sx={{mb: 1}}>Internet</Typography>
                {(!inProgress) && (
                    <Fragment>
                        <FormControlLabel
                            control={<Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)} />}
                            label={<Stack direction={'row'} alignItems={'center'}><span>I confirm my application is</span>&nbsp;<Link external target={'_blank'} href={'https://digitalplatoforms.totalenergies.com'}>ready to migrate</Link></Stack>}
                        />

                        <Alert sx={{mt: 2}} severity={'warning'} title={'Prepare you to a short interruption of service.'} />
                    </Fragment>
                )}

                {inProgress && (<Alert severity={'info'} title={'Internet migration is in progress'} />)}

                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} sx={{mt: 2}}>
                    <RequestHelp />
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'end'} spacing={1}>
                        <Button variant={'secondary'} startIcon={<Icon>undo</Icon>} disabled={inProgress} onClick={handlePrevious}>Rollback</Button>
                        <Button startIcon={<Icon>sync_alt</Icon>} onClick={handleNext} disabled={(!checked || inProgress)}>Migrate</Button>
                    </Stack>
                </Stack>
            </Box>
        </Fragment>
    )
}

export default Internet